// assets/quiz-question-render.js
// Cross-file dependency: filterOptionsForBranch from quiz-engine.js.
// In browser (Shopify CDN): available on window.* (relative imports break).
// In tests (Vitest): injected via setFilterFn or import in test setup.
let _filterFn = null;
export function setFilterFn(fn) { _filterFn = fn; }

export function renderQuestionInto(container, question, { branchId }) {
  const filterOptionsForBranch = _filterFn
    || (typeof window !== 'undefined' && window.filterOptionsForBranch);
  // Prompt
  const prompt = container.querySelector('.qz-prompt');
  prompt.textContent = question.prompt;
  // prompt focus handled by caller after render

  // Error element — one per question, id derived from question_id
  const errorId = `qz-err-${question.id}`;
  let err = container.querySelector('.qz-error');
  err.id = errorId;
  err.hidden = true;
  err.textContent = '';

  // Options group
  const wrap = container.querySelector('.qz-options-wrap');
  wrap.innerHTML = '';
  const isSingle = question.type === 'single';
  const group = document.createElement(isSingle ? 'div' : 'fieldset');
  group.className = 'qz-options';
  group.setAttribute('role', isSingle ? 'radiogroup' : 'group');
  group.setAttribute('aria-describedby', errorId);
  group.setAttribute('aria-labelledby', 'qz-current-prompt');

  const filtered = filterOptionsForBranch(question.options || [], branchId);
  const inputType = isSingle ? 'radio' : 'checkbox';
  filtered.forEach(opt => {
    const label = document.createElement('label');
    label.className = 'qz-option';
    const input = document.createElement('input');
    input.type = inputType;
    input.name = question.id;
    input.value = opt.value;
    if (opt.exclusive) input.dataset.exclusive = 'true';
    const span = document.createElement('span');
    span.textContent = opt.label;
    label.appendChild(input);
    label.appendChild(span);
    group.appendChild(label);
  });
  wrap.appendChild(group);
}

if (typeof window !== 'undefined') window.renderQuestionInto = renderQuestionInto;
